<div class="modal-header">
    <h4 class="modal-title">Planer til godkendelse</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Kundenr</th>
            <th scope="col">Firma</th>
            <th scope="col">Navn</th>
            <th scope="col">Klar</th>
            <th scope="col">Init</th>
        </thead>
        <tbody>
            <tr *ngFor="let client of planerTilGodkendelse"
            class="clickable"
            (click)="onClickPlan(client)">
                <td>{{client?.glkundenr}}</td>
                <td>{{client.navn1}}</td>
                <td>{{client.navn2}}</td>
                <td>{{client.plan_klar_til_godkendelse}}</td>
                <td>{{client.plan_klar_til_godkendelse_af}}</td>
            </tr>
        </tbody>
    </table>
</div>
